import type * as React from 'react';

import * as Styled from './icon-button.styles';
const { sizes } = Styled;

export type IconButtonSizes = keyof typeof sizes;

type CommonProps = {
  /** Add custom CSS */
  className?: string;
  /** Disable the TextButton */
  disabled?: boolean;
  /** Hand over an icon component for the IconButton */
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  /** Access the DOM node */
  innerRef?: React.RefObject<HTMLElement>;
  /** Loading state of the TextButton */
  loading?: boolean;
  /** @callback */
  onClick?: (e: MouseEvent) => void;
  /** The size on mobile screens or larger */
  size?: IconButtonSizes;
  /** The size on tablet screens or larger */
  sizeConfined?: IconButtonSizes;
  /** The size on desktop screens or larger */
  sizeWide?: IconButtonSizes;
};

type IconButtonHtmlProps = React.ComponentProps<typeof Styled.IconButton> &
  CommonProps & {
    href?: never;
    to?: never;
  };

type IconButtonRouterLinkProps = React.ComponentProps<
  typeof Styled.RouterIconButton
> &
  CommonProps;

export type IconButtonProps = IconButtonHtmlProps | IconButtonRouterLinkProps;
